import React, { useState, useEffect } from "react";
import FilterList from "../Components/Filter/FilterList";
import { useConfigureFooter } from "~hooks/useHelpers";
import ListSearchs from "../Components/Cards/ListSearchs";
import usePesquisasCampoClientes from "~fetchs/usePesquisasCampoClientes";
import { prepareData } from "../helpers/searchHelpers";
import ModalResponse from "~components/Modal/ModalResponse";
import useModalAction from "~components/Modal/hooks/useModalAction";

const ListResearch = () => {
  const [filters, setFilters] = useState({ searchText: "", status: "Todos", title: 0, validityPeriod: "Todos" });
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(5);
  const [loading, setLoading] = useState(false);
  const [searchsData, setSearchsData] = useState([]);
  const [searchsTitle, setSearchsTitle] = useState([]);

  const [showMessageModal, setShowMessageModal] = useState({
    text: "",
    type: "success",
  });

  const { isModalOpenAction: isModalResponse, closeModalAction: closeModalResponse, openModalAction: openModalResponse } = useModalAction();

  const { pesquisasCampoCliente, carregando, titulos } = usePesquisasCampoClientes({ filters, skip, take, setLoading });

  useEffect(() => {
    const { dados  } = prepareData(pesquisasCampoCliente);
    setSearchsData(dados);
  }, [pesquisasCampoCliente]);

  useEffect(() => {
    if(titulos) {
      setSearchsTitle([
        {
          title: "Todas",
          id: 0
        },
        ...titulos
      ]);
    }    
  }, [titulos])

  return (
    <>
      <FilterList onFilterChange={setFilters} titulos={searchsTitle} />
      <ListSearchs setShowMessageModal={setShowMessageModal} pesquisas={((searchsData ?? []) || [])} skip={skip} take={take} setSkip={setSkip} carregando={carregando} setLoading={setLoading} loading={loading} />

      {showMessageModal.text ? (
        <ModalResponse
          isOpen={true}
          closeModal={() => {
            const onClose = showMessageModal.onClose;
            setShowMessageModal((prev) => ({
              ...prev,
              text: "",
              onClose: () => {}
            }));

            closeModalResponse();

            if(onClose && typeof onClose == "function")
              onClose();
          }}
          status={showMessageModal.type ?? ""}
          message={showMessageModal.text ?? ""}
          submessage={showMessageModal.submessage ?? ""}
          button="Ok"
        />
      ) : null}
    </>
  );
};

export default ListResearch;
